import {Relationship} from "../../libs/enum/relationship.enum";
import {HttpMethod} from "../../libs/enum/http-method.enum";

export class PaypalLinkDto {

  public readonly href!: string;
  public readonly relationship!: Relationship;
  public readonly method!: HttpMethod;

  constructor(init?: Partial<PaypalLinkDto> | undefined) {
    Object.assign(this, init);
  }
}
